<template>
  <div class="d-flex">
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" fill="#F5F5F4" />
      <path
        d="M11 17V26.75C11 26.9489 11.079 27.1397 11.2197 27.2803C11.3603 27.421 11.5511 27.5 11.75 27.5H28.25C28.4489 27.5 28.6397 27.421 28.7803 27.2803C28.921 27.1397 29 26.9489 29 26.75V17L20 11L11 17Z"
        stroke="#1F1F1F"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M29 17L21.6406 22.25H18.3594L11 17"
        stroke="#1F1F1F"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</template>
